import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { constants, getMainPageLink, links, snowplow } from 'common/helpers'
import actions from 'redux/actions'

import Modal from 'components/modal/Modal/Modal'
import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import { Button } from 'components/_new/controls'

import messages from './messages'


const placement = 'preparing downgrade popup'

const PreparingDowngradeModal = ({ name }) => {

  const { isPaused, mainPageLink } = useConnect({
    isPaused: 'models.subscription.isPaused',
    mainPageLink: (state) => getMainPageLink({ state }),
  })

  const handleClick = useCallback(() => {
    if (isPaused) {
      snowplow.track('Unpause click', { placement }, false)
      actions.models.subscription.unpause({ placement, withSuccessHandler: false })
    }
    else {
      actions.models.subscription.setDowngrade(true)
      actions.models.router.push(links.cardUpdate)
    }

    actions.models.modals.close(name)
  }, [ name, isPaused ])

  const onClose = useCallback(() => {
    actions.models.router.push(mainPageLink)
  }, [ mainPageLink ])

  const btnTitle = isPaused ? messages.btnUnpause : messages.btnUnpaid
  const text     = isPaused ? messages.textUnpause : messages.textUnpaid

  return (
    <Modal name={name} onClose={onClose}>
      <Text message={text} />
      <Box mt={24}>
        <Button
          title={btnTitle}
          color="brand"
          size="md"
          onClick={handleClick}
        />
      </Box>
    </Modal>
  )
}

PreparingDowngradeModal.propTypes = {
  name: PropTypes.string.isRequired,
}

PreparingDowngradeModal.defaultProps = {
  name: constants.modals.PreparingDowngrade,
}


export default PreparingDowngradeModal
